module.exports = __webpack_public_path__ + "img/investor_LibraCapital@2x.ac3f8424.png";